import { NgModule } from '@angular/core';

import { EvaluationApiService } from './evaluation.service';

@NgModule({
    providers: [EvaluationApiService],
})
export class EvaluationApiModule {}

